import { render, staticRenderFns } from "./dr-file-viewer-pdf.vue?vue&type=template&id=5e090942&scoped=true&"
import script from "./dr-file-viewer-pdf.vue?vue&type=script&lang=js&"
export * from "./dr-file-viewer-pdf.vue?vue&type=script&lang=js&"
import style0 from "./dr-file-viewer-pdf.vue?vue&type=style&index=0&id=5e090942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e090942",
  null
  
)

export default component.exports